'use strict'
const ImageResize = {
    init: function(){
        this.updateImages();
        window.addEventListener('resize', this.updateImages);
    },
    updateImages: function(){
        const isMobile = window.innerWidth < 840;
        document.querySelectorAll('.imageResize').forEach((element) => {
            const mobileImage = element.getAttribute('data-mobile-image-url');
            const desktopImage = element.getAttribute('data-desktop-image-url');
            
            if (mobileImage && desktopImage) {
                element.style.backgroundImage = `url(${isMobile ? mobileImage : desktopImage})`;
            }
        });
        document.querySelectorAll('.imageResizeVideo').forEach((element) => {
            const mobileImage = element.getAttribute('data-mobile-image-url');
            const desktopImage = element.getAttribute('data-desktop-image-url');
            
            if (mobileImage && desktopImage) {
                element.setAttribute('poster', isMobile ? mobileImage : desktopImage);
            }
        });
    }
}
export default ImageResize;
